<script lang="ts">
    import {UIElement} from '../../../ui-elements/element';
    import ConfigListItem from "./ConfigListItem.svelte";
    import {OriginCoords} from '../../../types';

    export let selectedUiElements: UIElement[];
    export let origin: OriginCoords;
</script>

<div>
    {#key selectedUiElements}
        <div id="ui-elements-list">
            {#each selectedUiElements as uiElement (uiElement.id)}
                <ConfigListItem origin="{origin}" uiElement="{uiElement}"></ConfigListItem>
            {/each}
            {#if selectedUiElements.length === 0}
                <div>No ui element selected</div>
            {/if}
        </div>
    {/key}
</div>
<style>
    #ui-elements-list {
        grid-auto-rows: 100px;
    }
</style>
